import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { ProgressLessonContent } from '../states/lessons.state'

export const SET_LESSON_BLOCKS_PROGRESS = 'SET_LESSON_BLOCKS_PROGRESS'
export const SET_LESSON_BLOCKS_PROGRESS_SUCESS =
  'SET_LESSON_BLOCKS_PROGRESS_SUCESS'
export const CURRENT_LESSON_BLOCKS_PROGRESS = 'CURRENT_LESSON_BLOCKS_PROGRESS'
export const CURRENT_LESSON_BLOCKS_PROGRESS_SUCESS =
  'CURRENT_LESSON_BLOCKS_PROGRESS_SUCESS'

export const Actions = {
  setLessonBlockProgress: (data: any) =>
    createAction(SET_LESSON_BLOCKS_PROGRESS, data),
  setLessonBlockProgressSucess: (payload: {
    blockInstanceableId: number
    data: any
  }) => createAction(SET_LESSON_BLOCKS_PROGRESS_SUCESS, payload),
  currentLessonBlockProgress: (data: any) =>
    createAction(CURRENT_LESSON_BLOCKS_PROGRESS, data),
  currentLessonBlockProgressSucess: (payload: {
    blockInstanceableId: number
    id: number
    data: ProgressLessonContent
  }) => createAction(CURRENT_LESSON_BLOCKS_PROGRESS_SUCESS, payload),
}

export type Actions = ActionsUnion<typeof Actions>
